import { useEffect, useState } from "react";
import { fetchConfig, type AppConfig } from "../api/config";

const FALLBACK_CONFIG: AppConfig = {
  coupleNames: "Notre mariage",
  weddingDate: "",
  slideshowIntervalSeconds: 20,
  galleryPollIntervalSeconds: 15,
  guestPageReloadIntervalSeconds: 30,
  adminPollIntervalSeconds: 30,
  kioskReloadIntervalSeconds: 300,
  kioskVideoMaxSeconds: 15,
  kioskGuestbookIntervalSeconds: 300,
  kioskGuestbookMaxPerRound: 3,
  kioskGuestbookSeconds: 12,
  maxUploadSizeMb: 100,
  uploadsPaused: false,
  kioskReloadToken: -1,
  guestReloadToken: -1,
};

const POLL_INTERVAL_MS = 20_000;

export function useAppConfig(): AppConfig {
  const [config, setConfig] = useState<AppConfig>(FALLBACK_CONFIG);

  useEffect(() => {
    let cancelled = false;

    async function poll() {
      try {
        const latest = await fetchConfig();
        if (!cancelled) setConfig(latest);
      } catch {
        // Keep the last known config if /api/config is momentarily unreachable.
      }
    }

    void poll();
    const interval = setInterval(poll, POLL_INTERVAL_MS);
    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, []);

  return config;
}
